import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SONAR_PROJECT_RANGE_TYPE } from '../constants';

const useProjectRangeTypeOptions = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('daily'),
        value: SONAR_PROJECT_RANGE_TYPE.DAILY_RANGE,
      },
      {
        label: t('monthly'),
        value: SONAR_PROJECT_RANGE_TYPE.MONTHLY_RANGE,
      },
    ],
    [t],
  );
};

export default useProjectRangeTypeOptions;
